import { useEffect } from "react";
import EmailStep from "../components/auth/steps/EmailStep";
import { useMetaPixel } from "../hooks/useMetaPixel";

const LandingOfferPage = () => {
  const { trackEvent } = useMetaPixel();

  const handlePagoIniciado = () => {
    trackEvent("InitiateCheckout", { value: 39.99, currency: "USD" });
  };


  useEffect(() => {
    const script = document.createElement("script");
    script.innerHTML = `
      var head = document.head;
      var script = document.createElement('script');
      script.type = 'text/javascript';
      script.src = "https://213502.t.hyros.com/v1/lst/universal-script?ph=8037809a1b4fa13f47ce2be500afd8cdb7b5cdce93d6ab85b86324c2b73106b0&tag=!clicked&ref_url=" + encodeURI(document.URL) ;
      head.appendChild(script);
    `;
    document.head.appendChild(script);

    return () => {
      document.head.removeChild(script);
    };
  }, []);


  return (
    <div className="flex flex-col items-center justify-center h-screen bg-[#4f47e5]">
        <EmailStep onClose={() => {}} email={''} onNext={() => {}} offer={true} handlePagoIniciado={handlePagoIniciado} />
    </div>
  );
};

export default LandingOfferPage;